export default "__VITE_ASSET__Cbu5mKCL__"